export default __webpack_public_path__ + "static/media/slider4.c7a07b96.jpg";